import { fetcher } from '@commenda/utils';

import {
  IUpdateIndirectTaxCredentialParams,
  IUpdateIndirectTaxCredentialResponse,
} from './types';

export async function updateIndirectTaxCredential(
  credentialId: string,
  params: IUpdateIndirectTaxCredentialParams,
  token?: string
): Promise<{
  success: boolean;
  data?: IUpdateIndirectTaxCredentialResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/credentials/${credentialId}`,
      { method: 'POST', body: params },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to update credential',
      };
    }

    const data: IUpdateIndirectTaxCredentialResponse = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to update credential';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
